module.exports = __webpack_public_path__ + "media/slow2-h265.4c1c6646.mp4";